/*
 * Description of what this file is for
 *
 * @package  craft3
 * @author Stefan Prosch [hello@stefanprosch.com]
 * appHeader
 */

import hideOnScroll from 'hide-on-scroll';

import scrollMonitor from 'scrollmonitor';

const delay = ms => new Promise(_ => setTimeout(_, ms));

const appHeader = {
    cfg: {
        body: document.getElementsByTagName('body')[0],
        appHeader: document.querySelector('.js-appHeader'),
        mainNav: document.querySelector('.js-menu'),
        navWrapper: document.querySelector('.js-wrapper'),
        navBarToggle: document.querySelector('.js-navbarToggle'),
        navGroup: document.querySelectorAll('.js-groupItem'),
        navItem: document.querySelectorAll('.js-menuItem'),
        requestFormBtn: [...document.querySelectorAll('.js-linkRequest')],
        requestForm: document.querySelector('.js-requestForm'),
        requestFormWrapper: document.querySelector('.js-requestFormWrapper'),
        requestFormWrapperInner: document.querySelector('.js-requestFormWrapperInner'),
        section: document.querySelectorAll('.o-section--cb'),
        flashNotice: document.querySelectorAll('.o-appContent__flashNotices'),
        triggers: [...document.querySelectorAll('.js-groupItemLink')],
        status: 'is-open'
    },

    openForm() {
        // this.cfg.requestFormWrapper.classList.toggle('active');
        this.cfg.requestFormBtn.forEach(btn => {
            btn.classList.toggle('active');

            // Open Request Wrapper
            if (btn.classList.contains('active')) {
                this.cfg.requestFormWrapper.classList.add('active');
                this.cfg.body.classList.add('is-open--requestForm');
            } else {
                delay(200).then(() => this.cfg.requestFormWrapper.classList.remove('active'));
                this.cfg.body.classList.remove('is-open--requestForm');
            }

            if (this.cfg.navBarToggle.classList.contains('active')) {
                this.cfg.navWrapper.classList.remove('active');
                this.cfg.navBarToggle.classList.remove('active');
                delay(700).then(() => this.cfg.mainNav.classList.remove('active'));
                this.cfg.body.classList.remove('is-open--navigation');
            }
        });
    },

    // Toggle Content
    toggleAccordeon(event) {
        event.preventDefault();
        const target = event.currentTarget;
        // eslint-disable-next-line
        const tabContent = document.getElementById(target.dataset.tab); // target.nextElementSibling;
        const allTabs = document.querySelectorAll('.js-groupItemBlock');

        if (!target.classList.contains(this.cfg.status)) {
            allTabs.forEach((tab) => {
                tab.classList.remove(this.cfg.status);
            });
            this.cfg.triggers.forEach((trigger) => {
                trigger.classList.remove(this.cfg.status);
            });
            target.classList.add(this.cfg.status);
            tabContent.classList.add(this.cfg.status);

            // imageSlider.refreshSlider();
        } else {
            allTabs.forEach((tab) => {
                tab.classList.remove(this.cfg.status);
            });
            this.cfg.triggers.forEach((trigger) => {
                trigger.classList.remove(this.cfg.status);
            });
        }
    },

    init() {
        if (this.cfg.navBarToggle) {
            this.cfg.navBarToggle.addEventListener('click', () => {
                this.cfg.navWrapper.classList.toggle('active');
                this.cfg.navBarToggle.classList.toggle('active');

                if (this.cfg.navBarToggle.classList.contains('active')) {
                    this.cfg.mainNav.classList.add('active');
                    this.cfg.body.classList.add('is-open--navigation');
                } else {
                    delay(700).then(() => this.cfg.mainNav.classList.remove('active'));
                    this.cfg.body.classList.remove('is-open--navigation');
                }
            });

            this.cfg.navGroup.forEach((btn) => {
                btn.querySelector('a').addEventListener('click', (e) => {
                    this.toggleAccordeon(e);
                });
            });

            this.cfg.navItem.forEach((btn) => {
                btn.querySelector('a').addEventListener('click', (e) => {
                    if (this.cfg.navBarToggle.classList.contains('active')) {
                        this.cfg.navWrapper.classList.remove('active');
                        this.cfg.navBarToggle.classList.remove('active');
                        delay(700).then(() => this.cfg.mainNav.classList.remove('active'));
                        this.cfg.body.classList.remove('is-open--navigation');
                    }
                });
            });

            if (this.cfg.section[0]) {
                const elementWatcher = scrollMonitor.create(this.cfg.section[0]);

                // elementWatcher.lock();

                elementWatcher.exitViewport(() => {
                    this.cfg.appHeader.classList.add('o-appHeader--background');
                    // this.cfg.stickyButton.classList.add('is-visible');
                });

                elementWatcher.enterViewport(() => {
                    this.cfg.appHeader.classList.remove('o-appHeader--background');
                    // this.cfg.stickyButton.classList.remove('is-visible');
                });
            } else {
                this.cfg.appHeader.classList.add('o-appHeader--background');
            }
        }

        if (this.cfg.requestFormBtn) {
            this.cfg.requestFormBtn.forEach(button => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.openForm();
                });
            });

            document.addEventListener('click', (e) => {
                let targetElement = e.target;

                do {
                    // eslint-disable-next-line
                    if (targetElement === this.cfg.requestFormWrapper || targetElement === this.cfg.requestFormBtn[0] || targetElement === this.cfg.requestFormBtn[1] || targetElement === this.cfg.requestFormBtn[2]) {
                        return;
                    }
                    // Go up the DOM
                    targetElement = targetElement.parentNode;
                } while (targetElement);

                this.cfg.requestFormBtn.forEach(btn => {
                    if (btn.classList.contains('active')) {
                        this.cfg.requestFormWrapper.classList.remove('active');
                        btn.classList.remove('active');
                        delay(200).then(() => this.cfg.requestForm.classList.remove('active'));
                        this.cfg.body.classList.remove('is-open--requestForm');
                    }
                });
            });
        }

        hideOnScroll({
            navbarSelector: '.js-appHeader',
            hidingClass: 'is-hidden',
            pollingInterval: 500
        });

        hideOnScroll({
            navbarSelector: '.js-logo',
            hidingClass: 'is-hidden',
            pollingInterval: 500
        });

        hideOnScroll({
            navbarSelector: '.o-appContent__flashNotices',
            hidingClass: 'is-hidden',
            pollingInterval: 5000
        });
    }
};

export default appHeader;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/appHeader/_script.js